/**
 * File banner-carousel.js
 *
 * Handles Cards with links, making the entire card clickable.
 */

//if the page scroll add classes to the body. 'page-scrolled' and 'page-scrolled-25, 50, 75 or 100' to match the percentages
window.addEventListener( 'scroll', function () {
	var scroll = window.scrollY;
	var body = document.querySelector( 'body' );
	if ( scroll > 0 ) {
		body.classList.add( 'page-scrolled' );
	} else {
		body.classList.remove( 'page-scrolled' );
	}
	if ( scroll > window.innerHeight * 0.1 ) {
		body.classList.add( 'page-scrolled-10' );
	} else {
		body.classList.remove( 'page-scrolled-10' );
	}
	if ( scroll > window.innerHeight * 0.25 ) {
		body.classList.add( 'page-scrolled-25' );
	} else {
		body.classList.remove( 'page-scrolled-25' );
	}
	if ( scroll > window.innerHeight * 0.5 ) {
		body.classList.add( 'page-scrolled-50' );
	} else {
		body.classList.remove( 'page-scrolled-50' );
	}
	if ( scroll > window.innerHeight * 0.75 ) {
		body.classList.add( 'page-scrolled-75' );
	} else {
		body.classList.remove( 'page-scrolled-75' );
	}
	if ( scroll > window.innerHeight ) {
		body.classList.add( 'page-scrolled-100' );
	} else {
		body.classList.remove( 'page-scrolled-100' );
	}
} );
